module.exports = __webpack_public_path__ + "fa-duotone-900.svg?a1636ded8465b995f65eaf7ae76380e9";